// src/index.js
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client'; // 👈 CHANGED THIS IMPORT
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import process from 'process';

import { HelmetProvider } from 'react-helmet-async';
import { ToastProvider } from './ui/Toast';
import { ConfirmProvider } from './ui/ConfirmDialog';

window.process = process;

const container = document.getElementById('root');

const appContent = (
  <React.StrictMode>
    <HelmetProvider>
      <ToastProvider>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </ToastProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// 🪄 THE HYDRATION LOGIC:
if (container.hasChildNodes()) {
  hydrateRoot(container, appContent);
} else {
  const root = createRoot(container);
  root.render(appContent);
}

serviceWorkerRegistration.register();
reportWebVitals();